
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype4 as ObiMosfetPtype4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-4.js';
 
 
 

 
 export const ObiMosfetPtype4 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-4',
   elementClass: ObiMosfetPtype4Element,
   events: {
     
   }
  });
 
 